import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Row, Col, Button, Spinner } from 'react-bootstrap';
import FalconCloseButton from 'components/common/FalconCloseButton';

/**
 * Modal para confirmar el guardado de una orden
 */
const ModalConfirmarOrden = ({ 
    show, 
    onHide, 
    onConfirmar, 
    moneda, 
    confirmando,
    esEdicion = false,
    cambioDesdeFormaPorDefinir = false
}) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="md"
            backdrop="static"
            aria-labelledby="modal-confirmar-orden-title"
        >
            <Modal.Header>
                <Modal.Title id="modal-confirmar-orden-title">
                    &#191;Seguro?
                </Modal.Title>
                <FalconCloseButton 
                    className="btn btn-circle btn-sm transition-base p-0" 
                    onClick={onHide} 
                />
            </Modal.Header>
            <Modal.Body className="text-dark fs-2">
                <Row className="mb-3">
                    <Col>
                        {esEdicion && cambioDesdeFormaPorDefinir ? (
                            <>
                                Se eliminarán los <strong>links no pagados</strong> y todas las licencias 
                                asignadas al detalle de la orden se <strong>desasociaran</strong> si deseas continuar.
                            </>
                        ) : esEdicion ? (
                            <>
                                Todas las licencias asignadas al detalle de la orden se{' '}
                                <strong>desasociaran</strong> si deseas continuar.
                            </>
                        ) : (
                            <>
                                &#191; Est&aacute;s <strong>seguro</strong> que deseas guardar esta &oacute;rden{' '}
                                {moneda === '' ? (
                                    <strong className="text-danger">sin moneda</strong>
                                ) : (
                                    <strong className="text-danger">con moneda {moneda}</strong>
                                )}?
                            </>
                        )}
                    </Col>
                </Row>
                <Row>
                    <Col className="col-6">
                        {confirmando ? (
                            <Button variant="secondary" disabled className="col-12 fs--1">
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    className="me-2"
                                    aria-hidden="true"
                                />
                                Procesando...
                            </Button>
                        ) : (
                            <Button 
                                onClick={onConfirmar} 
                                variant="primary" 
                                className="col-12"
                            >
                                SI
                            </Button>
                        )}
                    </Col>
                    <Col className="col-6">
                        {confirmando ? (
                            <Button variant="secondary" disabled className="col-12 fs--1">
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    className="me-2"
                                    aria-hidden="true"
                                />
                                Procesando...
                            </Button>
                        ) : (
                            <Button 
                                onClick={onHide} 
                                variant="danger" 
                                className="col-12"
                            >
                                NO
                            </Button>
                        )}
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    );
};

ModalConfirmarOrden.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    onConfirmar: PropTypes.func.isRequired,
    moneda: PropTypes.string.isRequired,
    confirmando: PropTypes.bool.isRequired,
    esEdicion: PropTypes.bool,
    cambioDesdeFormaPorDefinir: PropTypes.bool
};

export default ModalConfirmarOrden;
